/* eslint-disable */
export default {
  tollFree: 'Gratuito',
  rcvPmiMeetingTitle: 'Reunión de vídeo de {extensionName}',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
